export const last = <T>(arr?: Array<T> | T): T | undefined => (arr && Array.isArray(arr)
  ? arr[arr.length - 1] : arr) as T | undefined;

export const difference = (
  firstArray: string[],
  secondArray: string[],
): string[] => [firstArray, secondArray].reduce((a, b) => a.filter((c) => !b.includes(c)));

export const cloneMap = <T, U>(
  map: Map<T, U> = new Map<T, U>(),
) => (map ? new Map<T, U>(map) : map);

export const moveArrayItem = <T>(
  array: T[] = [],
  initialPosition: number,
  finalPosition: number,
) => {
  if (initialPosition > array.length || finalPosition > array.length) return array;
  const newArray = [...array];
  const dragRow = newArray[initialPosition];
  newArray.splice(initialPosition, 1);
  newArray.splice(finalPosition, 0, dragRow);

  return newArray;
};

export const removeArrayByValue = <T extends string | number>(
  array: T[],
  toRemoveArray: T[],
) => array.filter((value) => !toRemoveArray.includes(value));

export const addArrayWithoutDuplicates = <T extends string | number>(
  array: T[],
  toAddArray: T[],
) => array.concat(toAddArray.filter((value) => !array.includes(value)));

export const sortAlfanumeric = (valueA: string, valueB: string): 1 | -1 | 0 => {
  if (valueA === valueB) return 0;
  if (valueA < valueB) return -1;
  return 1;
};
